/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';

import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import {
  CardContentContainer,
  CardContentTitle,
  ContentLink,
  ContentText,
  ContentTitle,
  EnrollSelectionCardContainer,
} from './styles';
import { benefitsForbiddenWords } from '../..';

type EnrollSelectionCardProps = {
  title: string;
  contentTitle: string;
  contentText: string;
  imgURL?: string;
  disabled?: boolean;
  selected?: boolean;
  onSelect?: Function;
};

const EnrollSelectionCard: React.FC<EnrollSelectionCardProps> = ({
  title,
  contentTitle,
  contentText,
  imgURL,
  disabled = false,
  selected = false,
  onSelect,
}) => {
  const [isSelected, setSelected] = useState(selected);

  useEffect(() => {
    setSelected(selected);
  }, [selected]);

  const handleSelection = () => {
    if (disabled) return;
    if (onSelect) {
      onSelect(title);
    }
  };

  return (
    <EnrollSelectionCardContainer disable={disabled} onClick={handleSelection} selected={isSelected}>
      <CardContentContainer>
        <CardContentTitle>{removeForbiddenWords(title, benefitsForbiddenWords)}</CardContentTitle>
        {/**
        <ContentTitle>{contentTitle}</ContentTitle>
        <ContentText>{contentText}</ContentText>
        <ContentLink />
         */}
      </CardContentContainer>
    </EnrollSelectionCardContainer>
  );
};

export default EnrollSelectionCard;
